import React, {Fragment} from 'react';
import {Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux';
import {bindActionCreators} from "redux";

import {fetchUserWarnings, resetUserWarnings} from "../../../creators/user.warnings";
import {fetchCurrentUser} from '../../../creators/currentUser';

import {Can} from "../../../ability-context";
import pictureShortLogo from '../../../images/logo_symbole.png'
import ProfileHeader from './components/ProfileHeader';
import Home from './components/Home';
import ProfileInformations from './components/ProfileInformations';
import ProfileAlbums from './components/ProfileAlbums';
import GalleryAlbum from './components/GalleryAlbum';
import {Button} from "../../components/Button";
import Warning from "../../components/warnings/Warning";
import {PageLoader} from "../../components/Loader";
import ProfileArticles from "./components/ProfileArticles";
import ProfileFriends from "./components/ProfileFriends";
import Modal from "../../components/Modal";
import createLink from "../../../libs/createLink";
import {fetchUserFriendsRequest, resetUserFriendsRequest} from "../../../creators/user.friendsRequest";
import {fetchUserFriends} from "../../../creators/user.friends";
import {config} from "../../../config";
import Helmet from "react-helmet";
import ProfileArticle from "./components/ProfileArticle";
import EmailValidation from "../../components/SignUpInformation/components/EmailValidation";
import _ from "lodash";
//import history from "../../../libs/history";
import {canonical, isNoFollowProfil} from "../../../libs/helper";
import {fetchUser, resetUser} from "../../../creators/user";
import ROUTES_CONFIG from "../../../routesConfig";
import ProfileSubNavigation from "./components/ProfileSubNavigation";
import ProfileExpendableDescription from "./components/ProfileExpendableDescription";
import Advertising from "../../components/Advertising/Advertising";
import {userViews} from "../../../creators/views";
import ErrorNotFound from "../ErrorNotFound";
import ProfileStatus from "./components/status/Status";
import ProfileNotificationStatus from "./components/notificationStatus/NotificationStatus";
import ProfileMedias from "./components/ProfileMedias";



const isAlert = sessionStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_alert`) || false;

class Profile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            userIsMe: _.get(this.props, 'match.params.userSlug') === _.get(this.props, 'currentUser.slug') || !_.get(this.props, 'match.params.userSlug'),
            toggleWarning: false,
            toggleSubmitPopup: (_.get(this.props.currentUser, 'role') === "emailUnconfirmed" && isAlert === false) || false
        };
        this.currentUrl = this.props.match;
        this.refHeader = React.createRef();

    }

    componentDidMount() {
        window.scrollTo(0, 0);
        this.props.resetUserWarnings();
        if (this.state.userIsMe) {
            this.props.fetchCurrentUser();
            this.props.fetchUserWarnings(this.props.currentUser._id);
            if(_.get(this.props,"currentUser._id")){
                this.props.fetchUserFriendsRequest(this.props.currentUser._id, {
                    status: 0,
                    limit : false,
                    sort : "-createdAt"
                });
                this.props.fetchUserFriends(this.props.currentUser._id);
            }

        } else {
            this.props.resetUser();
            this.props.fetchUser(this.props.match.params.userSlug).then((action)=>{
                let id = _.get(action,'payload._id');
                if(id) this.props.userViews(id);
                if(_.get(this.props,"currentUser._id")){
                    if(id) this.props.fetchUserWarnings(id);
                }
                //je desactive cette ligne car on a une redction vers le profile car on va sur un artcile
                // connecte avec esprit voissa
                // url : /blog-sexe-amateur/esprit-voissa/important-metamorphose-de-voissa-en-cours_61d362142e74400eb5d7fe78
                //if(_.get(action, 'payload.isAuthenticatedUser')) history.push(createLink('userMe', this.props.currentUser));
            });
        }
    }

    componentWillUnmount() {
        this.props.resetUserWarnings();
        if (this.state.userIsMe) {
            this.props.resetUserFriendsRequest();
        } else {
            this.props.resetUser();
        }
    }

    componentDidUpdate(prevProps) {
        if (!this.state.userIsMe) {
            if (prevProps.match.params.userSlug !== this.props.match.params.userSlug) {
                this.props.resetUser();
                this.props.resetUserWarnings();
                this.props.userViews(this.props.match.params.userSlug);
                this.props.fetchUser(this.props.match.params.userSlug);
                window.scrollTo(0, 0);
            }
            if (this.props.user._id && prevProps.user.slug !== this.props.user.slug) {
                // if(config.genderUrl[this.props.user.profile.gender] !== this.props.match.params[0]){
                //     history.push(createLink('userProfile', this.props.user));
                // }
                // if(this.props.currentUser && this.props.currentUser._id && (this.props.currentUser._id === this.props.user._id)){
                //     history.push(createLink('userMe', this.props.currentUser));
                // }

                //TODO: utile ? isIgnored non utilisé
                if (this.props.currentUser && this.props.currentUser._id) {
                    this.props.fetchUserFriends(this.props.user._id);
                    this.props.fetchUserWarnings(this.props.user._id);
                    let isIgnored = this.props.currentUser.usersIgnored && this.props.currentUser.usersIgnored.includes(this.props.user._id);
                    this.setState({isIgnored})
                }
            }
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(nextProps.userInitialized && _.get(nextProps, "history.location.hash") === "#profil-page"){
            window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
            const element = document.getElementById("profil-page");
            if (element) {
                /*console.log(element.offsetTop);
                element.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                    inline: "nearest"
                })*/
                window.scrollTo({
                    behavior: element ? "smooth" : "auto",
                    top: element ? element.offsetTop - 30 : 0
                });
            }
        }
        /*if(nextProps.userInitialized && _.get(nextProps, "history.location.hash") === "#addfriend"){
            window.history.replaceState(null, document.title, window.location.pathname + window.location.search);
            const element = document.getElementById("btn-add-friend");
            if (element) {
                element.click();
            }
        }*/
        let sharedCond = this.props.currentUserInitialized !== nextProps.currentUserInitialized
            || this.props.userWarningsInitialized !== nextProps.userWarningsInitialized
            || this.props.userFriendsTotal !== nextProps.userFriendsTotal
            || this.state.toggleWarning !== nextState.toggleWarning
            || (nextProps.userError.statusCode !== this.props.userError.statusCode && nextProps.userError.statusCode === 404)
        if (this.state.userIsMe) {
            return sharedCond || this.props.userFriendsRequestInitialized !== nextProps.userFriendsRequestInitialized
                || _.get(this.props.currentUser, "profile.cover") !== _.get(nextProps.currentUser, "profile.cover")
                || _.get(this.props.currentUser, "profile.avatar") !== _.get(nextProps.currentUser, "profile.avatar")
                || _.get(this.props.currentUser, "profile.isCompleted") !== _.get(nextProps.currentUser, "profile.isCompleted")
                || this.state.toggleSubmitPopup !== nextState.toggleSubmitPopup
                || nextProps.userWarningsTotal !== this.props.userWarningsTotal;
        } else {
            return sharedCond || this.props.userInitialized !== nextProps.userInitialized
                || this.props.user.isFriendRequestPending !== nextProps.user.isFriendRequestPending
                || this.props.user.isFollow !== nextProps.user.isFollow
                || nextProps.match.params.userSlug !== this.props.match.params.userSlug
                || nextProps.userWarningsTotal !== this.props.userWarningsTotal

        }
    }


    render() {

        let user = this.state.userIsMe ? this.props.currentUser : this.props.user;
        let userInitialized = this.state.userIsMe ? this.props.currentUserInitialized : this.props.userInitialized;
        if(_.get(this.props.userError,"statusCode") === 404){
            return <ErrorNotFound />
        }

        return !userInitialized || (!this.props.currentUserInitialized && this.props.currentUserLoading) ?
            <PageLoader/> : (
                <div id="profil">
                    <Helmet>
                        {this.state.userIsMe ? (
                            <title>{config.preTitle}Mon profil{config.postTitle}</title>
                        ) : (
                            <title>Profil Voissa de {user.username}</title>

                        )}
                        {isNoFollowProfil(user) || user.role === "banned" ? <meta name="robots" content="noindex" /> : null}
                        {user.role !== "banned" ? <meta name="description"
                              content={(_.get(user, "profile.description") || "").substring(0, 140)}/> : null}
                        <link rel="canonical" href={canonical(createLink('userProfile', user), "", "profile")}/>
                    </Helmet>
                    {user.role === "banned" ? (
                        <div className="container">
                            <img width={"200px"} src={pictureShortLogo} alt={"voissa"} style={{margin:"auto"}} />
                            <h3 className={"text-align-center pt-8"}>Ce compte a été bloqué par l’administrateur</h3>
                        </div>
                        ) : (
                        <div className="container">
                            <ProfileHeader
                                match={this.currentUrl}
                                isMe={this.state.userIsMe}
                                user={user}
                                forwardRef={this.refHeader}
                                onRef={ref => (this.refHeader = ref)}
                            />
                            <div className="layout-sidebar">
                                <div className="sidebar">
                                    <div className="btn-group column">
                                        {(this.state.userIsMe && this.props.userFriendsRequestTotal >= 1) && (
                                            <Button className="full mb-8"
                                                    to={createLink("userMeFriends")}
                                                    size={"medium"}
                                                    btnStyle={this.props.userFriendsRequestTotal >= 1 ? 'primary-reverse' : 'primary'}
                                                    badgeContent={this.props.userFriendsRequestTotal}
                                                    badgeStyle={this.props.userFriendsRequestTotal >= 1 ? 'red-reverse' : ''}
                                                    content={"Nouvelles demandes"}/>
                                        )}

                                        {this.props.userWarningsTotal > 0 ? (
                                            <Can action={"read"} subject="Warning">
                                                <Fragment>
                                                    <Button
                                                        className="full mb-8"
                                                        size={"medium"}
                                                        btnStyle={this.props.userWarningsTotal >= 1 ? 'cancel-reverse' : 'cancel'}
                                                        badgeContent={this.props.userWarningsTotal}
                                                        badgeStyle={this.props.userWarningsTotal >= 1 ? 'dark' : 'red-reverse'}
                                                        content="Messages de modération"
                                                        onClick={() => this.setState({toggleWarning: true})}
                                                        loading={this.props.userWarningsLoading}
                                                    />
                                                </Fragment>
                                            </Can>
                                        ) : null}
                                        {this.props.userWarningsTotal === 0 ? (
                                            <Can action={"create"} subject="Warning">
                                                <Fragment>
                                                    <Button
                                                        className="full mb-8"
                                                        size={"medium"}
                                                        btnStyle={this.props.userWarningsTotal >= 1 ? 'cancel-reverse' : 'cancel'}
                                                        badgeContent={this.props.userWarningsTotal}
                                                        badgeStyle={this.props.userWarningsTotal >= 1 ? 'dark' : 'red-reverse'}
                                                        content="Messages de modération"
                                                        onClick={() => this.setState({toggleWarning: true})}
                                                        loading={this.props.userWarningsLoading}
                                                    />
                                                </Fragment>
                                            </Can>
                                        ) : null}
                                        <Modal toggle={this.state.toggleWarning}
                                               handleClose={() => this.setState({toggleWarning: false})}>
                                            <Warning username={user.username}
                                                     userId={user._id}
                                                     handleClose={() => this.setState({toggleWarning: false})}/>
                                        </Modal>
                                        {(this.state.userIsMe && user.role === "emailUnconfirmed")
                                            && (
                                                <Button
                                                    className="full mb-8"
                                                    size={"medium"}
                                                    btnStyle={'cancel-reverse'}
                                                    content="Confirmer votre email"
                                                    onClick={() => this.setState({toggleSubmitPopup: true})}
                                                    loading={false}
                                                />
                                            )
                                        }
                                    </div>
                                    <ProfileExpendableDescription
                                        isMe={this.state.userIsMe}
                                        user={user}/>
                                    {user.role !== "banned" ? (
                                        <ProfileSubNavigation
                                            isMe={this.state.userIsMe}
                                            user={user}
                                            history={this.props.history}
                                        />
                                    ) : null}


                                    {/*<ProfileDescription
                                isMe={this.state.userIsMe}
                                user={user}
                                match={this.props.match}
                                location={this.props.location}
                                userLoading={userLoading}
                                userFriendsTotal={this.props.userFriendsTotal}
                                userInitialized={userInitialized}
                            />*/}

                                    {/*<LastVisitors userId={user._id}/>*/}
                                    {/*showLastVisitors={this.props.currentUser.setting.displayLastVisitors}*/}
                                    <Advertising sizeMobile={"300x100"} className={"center"} />
                                </div>
                                <div id={"profil-page"} className={"w-100"}>
                                    <Switch>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.ROOT}
                                               render={(props) => <Home {...props} isMe={this.state.userIsMe}
                                                                        user={user}
                                                                        currentUser={this.props.currentUser}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.STATUS}
                                               render={(props) => <ProfileStatus {...props} isMe={this.state.userIsMe}
                                                                        user={user}
                                                                        currentUser={this.props.currentUser}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.NOTIFICATIONSTATUR}
                                               render={(props) => <ProfileNotificationStatus {...props} isMe={this.state.userIsMe}
                                                                                 user={user}
                                                                                 currentUser={this.props.currentUser}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.DATING}
                                               render={(props) => <ProfileInformations {...props} updateMe={this.props.updateMe}
                                                                                       isMe={this.state.userIsMe}
                                                                                       user={user}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.ARTICLE}
                                               render={(props) => <ProfileArticle {...props}
                                                                                  isMe={this.state.userIsMe}
                                                                                  user={user}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.ARTICLES}
                                               render={(props) => <ProfileArticles {...props}
                                                                                   isMe={this.state.userIsMe}
                                                                                   user={user}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.ALBUM}
                                               render={(props) => <GalleryAlbum {...props}
                                                                                isMe={this.state.userIsMe}
                                                                                user={user}/>}/>
                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.ALBUMS}
                                               render={(props) => <ProfileAlbums {...props} currentPage="albums"
                                                                                 isMe={this.state.userIsMe}
                                                                                 user={user}/>}/>

                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.MEDIAS}
                                               render={(props) => <ProfileMedias {...props} currentPage="medias"
                                                                                 isMe={this.state.userIsMe}
                                                                                 user={user}/>}/>

                                        <Route exact path={ROUTES_CONFIG.PROFILE_MIXED.FRIENDS}
                                               render={(props) => <ProfileFriends {...props}
                                                                                  isMe={this.state.userIsMe}
                                                                                  currentUrl={`${this.props.match.url}/amis`}
                                                                                  user={user}/>}/>
                                        <Route component={ErrorNotFound} />
                                    </Switch>
                                </div>
                                {this.state.userIsMe && (
                                    <EmailValidation
                                        toggle={this.state.toggleSubmitPopup}
                                        handleClose={() => this.setState({toggleSubmitPopup: false})}
                                        avatar={_.get(user, 'profile.avatar')}
                                        gender={_.get(user, 'profile.gender')}
                                        email={_.get(user, 'email.address')}/>
                                )}
                            </div>
                        </div>
                    )
                    }
            </div>
        )
    }
}


const mapStateToProps = (state) => {
    return {
        user: state.user.data,
        userError: state.user.error,
        userLoading: state.user.loading,
        userInitialized: state.user.initialized,

        currentUser: state.currentUser.data,
        currentUserLoading: state.currentUser.loading,
        currentUserInitialized: state.currentUser.initialized,

        userWarningsTotal: state.userWarnings.total,
        userWarningsLoading: state.userWarnings.loading,
        userWarningsInitialized: state.userWarnings.initialized,

        userFriendsTotal: state.userFriends.total,

        userFriendsRequestTotal: state.userFriendsRequest.total,
        userFriendsRequestLoading: state.userFriendsRequest.loading,
        userFriendsRequestInitialized: state.userFriendsRequest.initialized,
    }
};

const mapDispatchToProps = (dispatch) => bindActionCreators({
    fetchUser,
    resetUser,
    fetchCurrentUser,

    fetchUserWarnings,
    resetUserWarnings,

    fetchUserFriendsRequest,
    resetUserFriendsRequest,
    fetchUserFriends,
    userViews
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Profile);
